import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * Chevrolet Tahoe (linkId 2365, project 59).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2365.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape. 16 variants = 8 trim/drivetrain combos x model years
 * 2025/2026; the 1.0 data reuses one configurationId across each year pair, so
 * most entities carry both variant keys in `relevantVariants` and only the few
 * whose SKU actually differs between years get a `-my26` key of their own.
 *
 * Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    Tahoe: {
      id: 'Tahoe',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      backgroundIdentifer: 'dome',
      variants: {
        'premier-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4980',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4917',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4927',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'premier-2wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4980',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4917',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4928',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'z71-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4979',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4912',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'rst-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4978',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4914',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4927',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-2wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4928',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'ls-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4927',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'ls-2wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4928',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'premier-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4980',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4917',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4927',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'premier-2wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4980',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4917',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4928',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'z71-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4979',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4912',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'rst-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4978',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4914',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4927',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-2wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4928',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'ls-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4927',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'ls-2wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '4921',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '4913',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '4910',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'drive_system',
              sku: '4928',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7081',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        }
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '7081',
          project: '59'
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '7082',
          project: '59'
        }
      },
      ambientLighting: {
        ambientColors: '',
        ambientLightings: {},
        relevantVariants: []
      },
      colors: {
        interior: {
          bmbnnt678r0o: {
            sku: '4917',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025',
              'premier-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          vltii7siyl2j: {
            sku: '4917',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025',
              'premier-2wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          uyr964nuipvo: {
            sku: '4912',
            project: '59',
            relevantVariants: [
              'z71-4wd-2025',
              'z71-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          dlhw2j4wp06f: {
            sku: '4914',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025',
              'rst-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '4s1b4jrlyp72': {
            sku: '4913',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '4fwo0ktql1c6': {
            sku: '4912',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          br6qka4lhl4f: {
            sku: '4913',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          oeiqe7hal1j3: {
            sku: '4912',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '9zod8og9izu9': {
            sku: '4913',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          nfs4tw1z0y5q: {
            sku: '4912',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '48za413x8262': {
            sku: '4913',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '48za413x82623': {
            sku: '4912',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ],
            notCompatibleExteriorColors: []
          }
        },
        exterior: {
          k550ufl2z63j: {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025',
              'premier-4wd-2026'
            ]
          },
          gxqxsxnaljfj: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025',
              'premier-4wd-2026'
            ]
          },
          '9i25yo15msgi': {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025',
              'premier-4wd-2026'
            ]
          },
          l415icrduyfe: {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025',
              'premier-4wd-2026'
            ]
          },
          t0ah6d0ze4xe: {
            sku: '4909',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025'
            ]
          },
          't0ah6d0ze4xe-my26': {
            sku: '6192',
            project: '59',
            relevantVariants: [
              'premier-4wd-2026'
            ]
          },
          ew6nnknehod1: {
            sku: '4907',
            project: '59',
            relevantVariants: [
              'premier-4wd-2025',
              'premier-4wd-2026'
            ]
          },
          c5rilpej5j26: {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025',
              'premier-2wd-2026'
            ]
          },
          o3nu3afykesw: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025',
              'premier-2wd-2026'
            ]
          },
          fs9rdujntrrb: {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025',
              'premier-2wd-2026'
            ]
          },
          d5ct2pjih82f: {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025',
              'premier-2wd-2026'
            ]
          },
          mi7h9vt1eqo1: {
            sku: '4909',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025'
            ]
          },
          'mi7h9vt1eqo1-my26': {
            sku: '6192',
            project: '59',
            relevantVariants: [
              'premier-2wd-2026'
            ]
          },
          aznfg8hzvuk5: {
            sku: '4907',
            project: '59',
            relevantVariants: [
              'premier-2wd-2025',
              'premier-2wd-2026'
            ]
          },
          qq29ff92khmy: {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'z71-4wd-2025',
              'z71-4wd-2026'
            ]
          },
          clohkdql579f: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'z71-4wd-2025',
              'z71-4wd-2026'
            ]
          },
          tesd2qbp9csg: {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'z71-4wd-2025',
              'z71-4wd-2026'
            ]
          },
          no2ztgqx4h18: {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'z71-4wd-2025',
              'z71-4wd-2026'
            ]
          },
          b6t97b02hemr: {
            sku: '4905',
            project: '59',
            relevantVariants: [
              'z71-4wd-2025'
            ]
          },
          'b6t97b02hemr-my26': {
            sku: '4905',
            project: '59',
            relevantVariants: [
              'z71-4wd-2026'
            ]
          },
          '5ydijea16amw': {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025',
              'rst-4wd-2026'
            ]
          },
          a38irmi8sgbh: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025',
              'rst-4wd-2026'
            ]
          },
          fso5sn4r0cx8: {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025',
              'rst-4wd-2026'
            ]
          },
          ry4r9fqb0aes: {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025',
              'rst-4wd-2026'
            ]
          },
          vt02zytt1nuj: {
            sku: '4909',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025'
            ]
          },
          'vt02zytt1nuj-my26': {
            sku: '4903',
            project: '59',
            relevantVariants: [
              'rst-4wd-2026'
            ]
          },
          '9do24jiu9hik': {
            sku: '4905',
            project: '59',
            relevantVariants: [
              'rst-4wd-2025',
              'rst-4wd-2026'
            ]
          },
          phik3xi1layc: {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          dsv2burvpj4y: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          kx78eegb5tx6: {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          fvoiamkx0yvo: {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          '54x2digmt4d0': {
            sku: '4907',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          g89wq89fizzz: {
            sku: '4903',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          r4pz2mma73zm: {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ]
          },
          c1asri6sqbvs: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ]
          },
          '52q7wm3fkk2r': {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ]
          },
          '54sh9pp059zy': {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ]
          },
          '74zty88mapb6': {
            sku: '4907',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ]
          },
          '5ygv706j1y4i': {
            sku: '4903',
            project: '59',
            relevantVariants: [
              'lt-2wd-2025',
              'lt-2wd-2026'
            ]
          },
          rjay25qlmny3: {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ]
          },
          xlqf75i2saml: {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ]
          },
          ab3bl6ua4odh: {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ]
          },
          '8h4v9q6ubtyq': {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ]
          },
          gsuts8nmckv2: {
            sku: '4903',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ]
          },
          oavzfo5fep46: {
            sku: '4907',
            project: '59',
            relevantVariants: [
              'ls-4wd-2025',
              'ls-4wd-2026'
            ]
          },
          '37xytt0490j8': {
            sku: '4910',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ]
          },
          '5xzh26yrdinw': {
            sku: '4906',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ]
          },
          '2fa06p9t7v8f': {
            sku: '4908',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ]
          },
          '10xy9i682nxc': {
            sku: '4904',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ]
          },
          '10xy9i682nxc4': {
            sku: '4903',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ]
          },
          '10xy9i682nxc5': {
            sku: '4907',
            project: '59',
            relevantVariants: [
              'ls-2wd-2025',
              'ls-2wd-2026'
            ]
          },
          vt02ttzytt1nuj: {
            sku: '4903',
            project: '59',
            relevantVariants: [
              'z71-4wd-2026'
            ]
          }
        }
      },
      features: {
        ylam62d7djz9: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Grill Pattern',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Grill Pattern',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kh1xk6tsachv: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1slkxz7syxvp': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kbns5f4ez323: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_22in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        k1gebz2rhrfs: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        '511hi24a2yfb': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        dk4jj9hgugds: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Sunroof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Sunroof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1dozmck8mjut': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Fog Lamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Fog Lamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y2e6haahw9vd: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y6zcqp9r8fln: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'Dashboard',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xsdac8nojc1s: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ddlwz0n6pzn8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '9cffzj69hili': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Rear Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Rear Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        e6jhw2a3jpjj: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Steering Shifter',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Steering Shifter',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        hnbca1qrws9d: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '19t5w7j2faxq': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        na9oo3ba0gf9: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Grill Pattern',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Grill Pattern',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        je1762muldx3: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '0hw6i0eruidm': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        qwurip7ebhzl: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_22in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        c7g9x5k81ma6: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            a9037m7w0amd: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        dvnbl0ekb85x: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        shbi0bb2sa3u: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Sunroof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Sunroof',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        k4xomlfi21su: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Fog Lamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Fog Lamps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '02a9r2m2zso3': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        g9s8rytddijb: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'Suspension',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        nrol7dpp8yd0: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'Dashboard',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zimbl7yvpilx: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        jzk46gu6adwb: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        bsqsmyygj2bg: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Rear Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Rear Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        mae94ricnkww: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Steering Shifter',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Steering Shifter',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        o6s36z8hkm4s: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '5glz7rcq53uo': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kyfij9hxv5nt: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '4wbktfrvcpql': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        wrbhrpf0p4mu: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xfjqlf6ze3pm: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_20in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        gbdtk5x81fz0: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Hooks',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Hooks',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3pn95exro9z6': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Tubular_side_step',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '5axgfh2btytx': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        bt48x44z13b4: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Wireless Charger',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wireless Charger',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        gbe4ixdirr8d: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Compartment',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Compartment',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        sdicuyai452l: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3re5wmqz3dw5': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2hc2o7cuwka9': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'Steering Shifter',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2je8obbpqtv4': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          messages: [
            {
              message: 'Paddle Shifters',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        gx1i3vxge08y: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zja8v4elqyko: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        d66subt9qz7a: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ai6x6p4bqkhj: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_22in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '4bt3sofsvx58': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Badges',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Badges',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1oq2uhwagoto': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3n0e27xt3f7y': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ofq9cjmv0dio: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '80a8vikbz9mc': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Compartment',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Compartment',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        goge77bzjpog: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'Irvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3hptb1jmkv9t': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          messages: [
            {
              message: 'Wireless Charger',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Wireless Charger',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '4xrp3r6xunkh': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        lddmksxt2r3x: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        vygkaurpl8hc: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        k5z4vhfjy8wq: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '95z9ngnfewd5': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        a7p16fyqm946: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Assist_Step',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        lhlx7rjoaop9: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        iufy8ebzwn55: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '07zc5saopyb5': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        iuwst0brv0wh: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '0z5t34x4biok': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Onstar',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Onstar',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        eg5mmj97g8xe: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: true,
              snapToLastFrame: false
            }
          }
        },
        kj9lo5riyd1n: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Lift gate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        sf21sgxeu6ko: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        yp4i3p3de1f5: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        yvg1m8p6pndx: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        eg09maxszliz: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        qynhf9eb50dh: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ksocutusfs7r: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Assist_Step',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Side Steps',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '7pxtwa8ynuz1': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        dc9ffp35wvdd: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '7ihmnpfmjain': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        jl9mgtoi4fpn: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        v9x8tbkmmr7f: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Onstar',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Onstar',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        sbtsc5srgjg3: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: true,
              snapToLastFrame: false
            }
          }
        },
        qjqmesrzf9i7: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          messages: [
            {
              message: 'Lift gate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        jfc6k9282sps: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        d8iqszv1qgtg: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            glpt65jo78y2: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        l4jlplnah2pk: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '8ih09bnziphj': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '0rb2gy4ywuo8': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ns2sioa1qkk2: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xgabr5lafxj5: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zf9hwe5w90h7: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        s47kkorg502l: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        grprosxs87va: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3sa90kby1ubz': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          messages: [
            {
              message: 'Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '29kx4ja7eg7r': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3ud49gqncb2e': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Orvm',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            f9s7b4hdeiz7: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        '1jhh1m7485kl': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Fascia',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        einjxmvv1rxf: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        mw3hss4999re: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Roof Carrier',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        b7xdnq4ptvlx: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Taillamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        bf5spqe7qghc: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2kzy6a0jhsu2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zq18jgsgj1sc: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '4cq85subl38y': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'Front Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          messages: [
            {
              message: 'Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Front and Rear AC',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        }
      },
      accessories: {
        j8gbkfpqangk: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wdbc64xihtb2: {
          view: 'exterior',
          groupId: 'premier-4wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFALT_ENHANCED_VISIBILTY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        as1rluq401n7: {
          view: 'exterior',
          groupId: 'premier-4wd-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_ENHANCED_VISIBILTY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8k3kqiy0rpwl': {
          view: 'exterior',
          groupId: 'premier-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'R4C',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vy9a4fqiu3mi: {
          view: 'exterior',
          groupId: 'premier-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u20m3d5j71vd: {
          view: 'exterior',
          groupId: 'premier-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        f4jur4qda1iy: {
          view: 'exterior',
          groupId: 'premier-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_BEZEL_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3l56f6t8yrhk': {
          view: 'exterior',
          groupId: 'premier-4wd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_BEZEL_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0agqewqxtxza': {
          view: 'exterior',
          groupId: 'premier-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8m3lbfnbgjgt': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        an4yb9ia2pck: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ck165ih65lno: {
          view: 'exterior',
          groupId: 'premier-4wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xfkdiah0cnde: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates Premier',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_Premier',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            },
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        juaj9a2rptxz: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tapbu8okt0uj: {
          view: 'exterior',
          groupId: 'premier-4wd-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4by5qhwuy594': {
          view: 'exterior',
          groupId: 'premier-4wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mr7qy5fo5qhm: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PREMIER_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wf9709z90ina: {
          view: 'exterior',
          groupId: 'premier-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: '22 inch Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4fjgp644j954': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0wu0cglndrqc': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u4l2ea4u591d: {
          view: 'exterior',
          groupId: 'premier-2wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFALT_ENHANCED_VISIBILTY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zdstqruyal13: {
          view: 'exterior',
          groupId: 'premier-2wd-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_ENHANCED_VISIBILTY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qz1xkch699vj: {
          view: 'exterior',
          groupId: 'premier-2wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'R4C',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ouphufegebch: {
          view: 'exterior',
          groupId: 'premier-2wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '73ocxc2sdp6r': {
          view: 'exterior',
          groupId: 'premier-2wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '537stl5m1lxj': {
          view: 'exterior',
          groupId: 'premier-2wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_BEZEL_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wgwpi0cpuvm1: {
          view: 'exterior',
          groupId: 'premier-2wd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_BEZEL_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '220sgfu4ue0x': {
          view: 'exterior',
          groupId: 'premier-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n8yi3roj6gyz: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            a9037m7w0amd: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jcnivvs85wga: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ygbf6qmc6kke: {
          view: 'exterior',
          groupId: 'premier-2wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        grvysusnjiab: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates Premier',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_Premier',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            a9037m7w0amd: {
              add: false,
              snapToLastFrame: true
            },
            '9vjnbyvcm8ye': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        atupcjelnx02: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            a9037m7w0amd: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u7mrz45son0v: {
          view: 'exterior',
          groupId: 'premier-2wd-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '9vjnbyvcm8ye': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hchvsg67r27z: {
          view: 'exterior',
          groupId: 'premier-2wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '59w2od9p35l4': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PREMIER_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wf9709z90ina23: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wf9709z90ina34: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '63y0kvv7xxr2': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '0vth6kpxs1jg': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ocbn9q1rvely: {
          view: 'exterior',
          groupId: 'z71-4wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ctvxw4vspn8n: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        asyqhfvwphz6: {
          view: 'exterior',
          groupId: 'z71-4wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6wndqn4xdcpe': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '0vth6kpxs1jg': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fgzwkqgju86l: {
          view: 'exterior',
          groupId: 'z71-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            kisy9chslzdy: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2k5neto3ntiw': {
          view: 'exterior',
          groupId: 'z71-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_ROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ze9qelaq0ea7: {
          view: 'exterior',
          groupId: 'z71-4wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_SUNROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kxve94jfxnjn: {
          view: 'exterior',
          groupId: 'z71-4wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_TECHNOLOGY_PACKAGE_RST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ow69hy698vfs: {
          view: 'exterior',
          groupId: 'z71-4wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_TECHNOLOGY_PACKAGE_RST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zpdxf0ojy1ys: {
          view: 'exterior',
          groupId: 'z71-4wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'R4M',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        filx1puwuu5x: {
          view: 'exterior',
          groupId: 'z71-4wd-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        o5djqpf4c2zz: {
          view: 'exterior',
          groupId: 'z71-4wd-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '786orlp7brpi': {
          view: 'exterior',
          groupId: 'z71-4wd-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        do59cklquwhw: {
          view: 'exterior',
          groupId: 'z71-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '50bp9axsjq0b': {
          view: 'exterior',
          groupId: 'z71-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8e344wbsrdwe': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Z71_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dyotlhu6y13v: {
          // Rear entertainment screen sits inside the cabin - 'interior' so
          // applying it flips the EXT/INT toggle like Floor Mat-Chrome does.
          view: 'interior',
          groupId: 'z71-4wd-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_REAR_SCREEN_Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SCREEN_Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7d7txgmtnv90': {
          view: 'interior',
          groupId: 'z71-4wd-g6',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_MEMORY_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '0vth6kpxs1jg': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        uzlkrbqqpemr: {
          view: 'interior',
          groupId: 'z71-4wd-g6',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        z0at7jbpskb3: {
          view: 'exterior',
          groupId: 'rst-4wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_ROOF_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(DEFAULT_BENCH_SEAT) in accessories of (common_exterior)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'DEFAULT_ROOF_CAP_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(ACC_BUCKET_SEAT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rye7d6mc16r0: {
          view: 'exterior',
          groupId: 'rst-4wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_SUNROOF_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(DEFAULT_BENCH_SEAT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_SUNROOF_CAP_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(ACC_BUCKET_SEAT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        emj5q4fdnout: {
          view: 'interior',
          groupId: 'rst-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_BENCH_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_ROOF_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(DEFAULT_ROOF_CAP_RST) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_SUNROOF_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(ACC_SUNROOF_CAP_RST) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_HEATED_BUCKET) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_HEATED_BUCKET) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4c61rda34zee': {
          view: 'interior',
          groupId: 'rst-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_BUCKET_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_ROOF_CAP_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(DEFAULT_ROOF_RST) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_SUNROOF_CAP_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '(ACC_SUNROOF_RST) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_HEATED_BENCH) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_HEATED_BENCH) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_MIDDLE_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4tihcmimu2ok': {
          view: 'exterior',
          groupId: 'rst-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SGF',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fpn25sp5gphy: {
          view: 'exterior',
          groupId: 'rst-4wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9oh6k48k8cxx': {
          view: 'exterior',
          groupId: 'rst-4wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jqxngcgzuv9b: {
          view: 'exterior',
          groupId: 'rst-4wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8wr423b2htlh': {
          view: 'exterior',
          groupId: 'rst-4wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ACC_W_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gfbqa4vsn2wr: {
          view: 'exterior',
          groupId: 'rst-4wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_TECHNOLOGY_PACKAGE_RST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kfu51ifirrz4: {
          view: 'exterior',
          groupId: 'rst-4wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_TECHNOLOGY_PACKAGE_RST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9kyqypnk8s04': {
          view: 'exterior',
          groupId: 'rst-4wd-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        e3cpetqtxy02: {
          view: 'exterior',
          groupId: 'rst-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_BENCH_SEAT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_BUCKET_SEAT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tibyw2x77m3a: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            dscofhz7g4yx: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ujk0lpogtp9a: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2jfy7wddw2lw': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates RST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_RST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            dscofhz7g4yx: {
              add: false,
              snapToLastFrame: true
            },
            xy419msn5u11: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rvqnxfvkbwf6: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0bsfsmin2z34': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ACC_ADVANCED_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vr811gju19tq: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zano5i0m9vpm: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RST_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jmfvwre4e5wl: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dlanz97wztgs: {
          view: 'exterior',
          groupId: 'lt-4wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_HIGH_APPROACH_FASCIA',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_WO_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        x0ewn8d547lf: {
          view: 'exterior',
          groupId: 'lt-4wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_STREET_FRONT_FASCIA_LT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_WO_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_WO_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_GRILL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8o2g0vdgczzb': {
          view: 'exterior',
          groupId: 'lt-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_ROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fpfkrtu6uh3e: {
          view: 'exterior',
          groupId: 'lt-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_SUNROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '76yy5aew7ka9': {
          view: 'exterior',
          groupId: 'lt-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_FRONT_BENCH_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xnm43hp741wy: {
          view: 'interior',
          groupId: 'lt-4wd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_FRONT_BUCKET_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lmzjn7akfeiz: {
          view: 'interior',
          groupId: 'lt-4wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_WIRELESS_CHARGER_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1mavqo62dsmu': {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RCV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3baaofq60q2o': {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        psqnhs79c4zr: {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        eaaz58mmbiz8: {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fuw0owjjsik1: {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4jy3fhzypv8n': {
          view: 'exterior',
          groupId: 'lt-4wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_TECHNOLOGY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_TECHNOLOGY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9ahip044pcui': {
          view: 'exterior',
          groupId: 'lt-4wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_TECHNOLOGY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h0o57uwnp9eq: {
          view: 'exterior',
          groupId: 'lt-4wd-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_LUXURY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'ACC_WO_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qrlyo2fi1cz5: {
          view: 'exterior',
          groupId: 'lt-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_LUXURY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'ACC_W_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gr212v81y9j8: {
          view: 'exterior',
          groupId: 'lt-4wd-g6',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ilcd1ac7uwte: {
          view: 'exterior',
          groupId: 'lt-4wd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_FRONT_BENCH_CONSOLE_LS) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_FRONT_BUCKET_CONSOLE_LS) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_WIRELESS_CHARGER_LT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0liobyyvrpud': {
          view: 'exterior',
          groupId: 'lt-4wd-g7',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '22r2iguvwna5': {
          view: 'exterior',
          groupId: 'lt-4wd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5y8auet27vap': {
          view: 'exterior',
          groupId: 'lt-4wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        q2jxwuubfmts: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2tgsrkgxlq2n': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mu1nnlb77i13: {
          view: 'exterior',
          groupId: 'lt-4wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        q0kpkldh7h9h: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: false,
              snapToLastFrame: true
            },
            n3srfdzi1l8y: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9bh9bo8nka30': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s6yov9pn3z94: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        flcd4tk3152i: {
          view: 'exterior',
          groupId: 'lt-4wd-g9',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            n3srfdzi1l8y: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b47ijnigxias: {
          view: 'exterior',
          groupId: 'lt-4wd-g9',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        p2k3ocymx5b6: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ka15u2dvchya: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        r1n54l44td0x: {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: '22 inch Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tautgpnlntno: {
          view: 'interior',
          groupId: 'lt-4wd-g10',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_LT_INFOSCREEN',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_INFO_SCREEN',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '621q9g1g6arh': {
          view: 'interior',
          groupId: 'lt-4wd-g10',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [
            {
              message: 'CAMERA_INFO_SCREEN',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              '4s1b4jrlyp72'
            ],
            exterior: []
          }
        },
        l9o7n2dgqf4r: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [
            {
              message: 'CAMERA_8_WAY_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              '4s1b4jrlyp72'
            ],
            exterior: []
          }
        },
        mtjkzka4hyry: {
          view: 'interior',
          groupId: 'lt-4wd-g11',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_MEMORY_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            nr092e0zwxmq: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              '4s1b4jrlyp72'
            ],
            exterior: []
          }
        },
        '6wqyiqzo0qbj': {
          view: 'interior',
          groupId: 'lt-4wd-g11',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mh8yll2ghfym: {
          view: 'exterior',
          groupId: 'lt-2wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_HIGH_APPROACH_FASCIA',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_WO_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1mvpa42b7x58': {
          view: 'exterior',
          groupId: 'lt-2wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_STREET_FRONT_FASCIA_LT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_WO_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_WO_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_GRILL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bmut9gj383kz: {
          view: 'exterior',
          groupId: 'lt-2wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_ROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0zwxk45hp9q3': {
          view: 'exterior',
          groupId: 'lt-2wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_SUNROOF',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zwlfrhv0um37: {
          view: 'exterior',
          groupId: 'lt-2wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_FRONT_BENCH_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pg7vdt72cjtt: {
          view: 'interior',
          groupId: 'lt-2wd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_FRONT_BUCKET_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s2zs0r60v7n1: {
          view: 'interior',
          groupId: 'lt-2wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_WIRELESS_CHARGER_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3lxqq538zwmd': {
          view: 'exterior',
          groupId: 'lt-2wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RCV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        txaq2clwjh4b: {
          view: 'exterior',
          groupId: 'lt-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jxm0gmjcapku: {
          view: 'exterior',
          groupId: 'lt-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qxnu1ufa5f2l: {
          view: 'exterior',
          groupId: 'lt-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ookmqq6bquqm: {
          view: 'exterior',
          groupId: 'lt-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6di4c84i0dy0': {
          view: 'exterior',
          groupId: 'lt-2wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_TECHNOLOGY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_TECHNOLOGY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yn2ooyds378y: {
          view: 'exterior',
          groupId: 'lt-2wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_TECHNOLOGY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4n7vrcx493gx': {
          view: 'exterior',
          groupId: 'lt-2wd-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_LUXURY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'ACC_WO_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_W_LUXURY_PACKAGE) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mwawbqfdlt3b: {
          view: 'exterior',
          groupId: 'lt-2wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_LUXURY_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_HIGH_APPROACH_FASCIA) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'ACC_W_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_STREET_FRONT_FASCIA_LT) in accessories of (exterior-color)',
              isDefault: false,
              isStop: true
            },
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: true
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gx72l1mz30pe: {
          view: 'exterior',
          groupId: 'lt-2wd-g6',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2plajrmvths5': {
          view: 'exterior',
          groupId: 'lt-2wd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_COMFORT_PACKAGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BENCH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(DEFAULT_FRONT_BENCH_CONSOLE_LS) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_FRONT_BUCKET_CONSOLE_LS) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_W_HEATED_BUCKET',
              identifiers: [
                'common_exterior'
              ],
              condition: '(ACC_WIRELESS_CHARGER_LT) in accessories of (common_exterior)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1rx23hesytaa': {
          view: 'exterior',
          groupId: 'lt-2wd-g7',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        oakqa7avxhmq: {
          view: 'exterior',
          groupId: 'lt-2wd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ptvlbx4oakbu: {
          view: 'exterior',
          groupId: 'lt-2wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lrpq8u8zpdb1: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2f2ldbh1iacq': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lsc3om940tkg: {
          view: 'exterior',
          groupId: 'lt-2wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        k1tgm4d8un58: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: false,
              snapToLastFrame: true
            },
            a0b4x8u9auhj: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3fuv04x49k8u': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Sill Plates',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        czxgco8l62fv: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gdi5279zy1a2: {
          view: 'exterior',
          groupId: 'lt-2wd-g9',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            a0b4x8u9auhj: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        t7nql3o89wl9: {
          view: 'exterior',
          groupId: 'lt-2wd-g9',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        iealvlwfdrg1: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        iealvlwfdrg12: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_MANUAL_IRVM_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        oiv75228zve7: {
          view: 'exterior',
          groupId: 'lt-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: '22 inch Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ig3l66uxabo4: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [
            {
              message: 'CAMERA_INFO_SCREEN',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025'
          ],
          notAvailableForColor: {
            interior: [
              'br6qka4lhl4f'
            ],
            exterior: []
          }
        },
        'ig3l66uxabo4-my26': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [
            {
              message: 'CAMERA_INFO_SCREEN',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              'br6qka4lhl4f'
            ],
            exterior: []
          }
        },
        tautgpnlntnoffwef: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [
            {
              message: 'CAMERA_8_WAY_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              'br6qka4lhl4f'
            ],
            exterior: []
          }
        },
        l9o7n2dgqf4r32: {
          view: 'interior',
          groupId: 'lt-2wd-g10',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_MEMORY_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            hwol9wjk8u5f: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              'br6qka4lhl4f'
            ],
            exterior: []
          }
        },
        l9o7n2dgqf4r321: {
          view: 'interior',
          groupId: 'lt-2wd-g10',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MEMORY_DRIVER_SEAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mre7m5eq7pp3: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            glpt65jo78y2: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rgm1s2u48s3z: {
          view: 'exterior',
          groupId: 'ls-4wd-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        w2einnny5a2l: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h1qdprk0kd0p: {
          view: 'exterior',
          groupId: 'ls-4wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8lz29kitnkam': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates TAHOE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_TAHOE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            glpt65jo78y2: {
              add: false,
              snapToLastFrame: true
            },
            t6e4q7plmhff: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5zc0rx55r9q9': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dq9u6gqmbzk1: {
          view: 'exterior',
          groupId: 'ls-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            t6e4q7plmhff: {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mydj9h508fxd: {
          view: 'exterior',
          groupId: 'ls-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        itbl6bdvdboy: {
          view: 'exterior',
          groupId: 'ls-4wd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pe7y08bs0zcn: {
          view: 'exterior',
          groupId: 'ls-4wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RCV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        no2apmxabsv7: {
          view: 'exterior',
          groupId: 'ls-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '03hdnt4slw1j': {
          view: 'exterior',
          groupId: 'ls-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ugyico57fj8q: {
          view: 'exterior',
          groupId: 'ls-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2xg5fkuod39v': {
          view: 'exterior',
          groupId: 'ls-4wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_FRONT_BENCH_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vq7tvvssnsow: {
          view: 'interior',
          groupId: 'ls-4wd-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_FRONT_BUCKET_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qk56aim53mo1: {
          view: 'exterior',
          groupId: 'ls-4wd-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_HIGH_APPROACH_FASCIA',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bz0b6bnb2d3x: {
          view: 'exterior',
          groupId: 'ls-4wd-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_STREET_FRONT_FASCIA_LT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_WO_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_GRILL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mfsw9xounf28: {
          view: 'exterior',
          groupId: 'ls-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        o50knbpnx8xn: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LS_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b9hh0ghhfnsm: {
          view: 'exterior',
          groupId: 'ls-4wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: '22 inch Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '60cyi4386dh7': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Bowtie Logo Puddle Lights ',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            f9s7b4hdeiz7: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ckvx6gvve67': {
          view: 'exterior',
          groupId: 'ls-2wd-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Bowtie Emblems',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '26awwpydj3k4': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Floor Mat-Chrome',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER__MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4g3h4ls28grj': {
          view: 'exterior',
          groupId: 'ls-2wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Illuminated Black Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '56cy0d0cnz7u': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Nameplates TAHOE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Nameplates_TAHOE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            f9s7b4hdeiz7: {
              add: false,
              snapToLastFrame: true
            },
            '1nad76ictp6j': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '496aqzregvz5': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Exhaust Tip',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4e8rsvm8yulq': {
          view: 'exterior',
          groupId: 'ls-2wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Cargo Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '1nad76ictp6j': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ukt6vqkkvuhg: {
          view: 'exterior',
          groupId: 'ls-2wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_WO_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ckvx6gvve79': {
          view: 'exterior',
          groupId: 'ls-2wd-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_W_MAX_TRAILERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ij5dojjdjzao: {
          view: 'exterior',
          groupId: 'ls-2wd-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RCV',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xxu51rvhkatu: {
          view: 'exterior',
          groupId: 'ls-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'NZW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        trux0ouskla2: {
          view: 'exterior',
          groupId: 'ls-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SII',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        grbqqvyo3nmg: {
          view: 'exterior',
          groupId: 'ls-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SIY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vvjg0ome82jt: {
          view: 'exterior',
          groupId: 'ls-2wd-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_FRONT_BENCH_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0s5749peesms': {
          view: 'interior',
          groupId: 'ls-2wd-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_FRONT_BUCKET_CONSOLE_LS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ixr3i03h2o98: {
          view: 'exterior',
          groupId: 'ls-2wd-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_HIGH_APPROACH_FASCIA',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'DEFAULT_WO_FOG_HIGH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ckvx6gvve78': {
          view: 'exterior',
          groupId: 'ls-2wd-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_STREET_FRONT_FASCIA_LT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'ACC_WO_FOG_STREET',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FRONT_GRILL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4e8rsvm8yulq1': {
          view: 'exterior',
          groupId: 'ls-2wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'DEFAULT_Cargo Area Sill Plate',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4e8rsvm8yulq12': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LS_VARIANT_PARTS',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mr7qy5fo6qhm: {
          view: 'exterior',
          groupId: 'ls-2wd-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: '22 inch Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'ACC_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'SHADER_Black Wheels',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        }
      },
      packages: {
        x7vtyrufcgr0: {
          groupId: 'premier-4wd-pkg0',
          accessoryIds: [
            'as1rluq401n7'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        sd9rqxud0aff: {
          groupId: 'premier-4wd-pkg1',
          accessoryIds: [],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        y9jkjnvpik8v: {
          groupId: 'premier-2wd-pkg0',
          accessoryIds: [
            'zdstqruyal13'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        r5wqfoofy7qd: {
          groupId: 'premier-2wd-pkg1',
          accessoryIds: [],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        e16fx2pwr5c6: {
          groupId: 'z71-4wd-pkg0',
          accessoryIds: [
            'ow69hy698vfs'
          ],
          dependencyPackages: [
            {
              id: '0m9r9b96ve38',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        '0m9r9b96ve38': {
          groupId: 'z71-4wd-pkg0',
          accessoryIds: [
            'do59cklquwhw'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        hcjds82xe95h: {
          groupId: 'rst-4wd-pkg0',
          accessoryIds: [
            'kfu51ifirrz4'
          ],
          dependencyPackages: [
            {
              id: 'd0reb1sp8t84',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ]
        },
        d0reb1sp8t84: {
          groupId: 'rst-4wd-pkg0',
          accessoryIds: [
            'e3cpetqtxy02'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'rst-4wd-2025'
          ]
        },
        'd0reb1sp8t84-my26': {
          groupId: 'rst-4wd-pkg0',
          accessoryIds: [
            'e3cpetqtxy02'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'rst-4wd-2026'
          ]
        },
        '17qszcfj0bo2': {
          groupId: 'lt-4wd-pkg1',
          accessoryIds: [
            '22r2iguvwna5'
          ],
          dependencyPackages: [
            {
              id: 'y2dzpqaviuzr',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        k8mse77gto6i: {
          groupId: 'lt-4wd-pkg0',
          accessoryIds: [
            '9ahip044pcui'
          ],
          dependencyPackages: [
            {
              id: 'a5chmgxs7219',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        a5chmgxs7219: {
          groupId: 'lt-4wd-pkg0',
          accessoryIds: [
            'ilcd1ac7uwte'
          ],
          dependencyPackages: [
            {
              id: '7jbrmnpu41z1',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        kdcvdi12qfge: {
          groupId: 'lt-4wd-pkg0',
          accessoryIds: [
            '5y8auet27vap',
            'q0kpkldh7h9h',
            's6yov9pn3z94'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        q1rjmnbq9vgu: {
          groupId: 'lt-4wd-pkg0',
          accessoryIds: [
            'q2jxwuubfmts',
            'mu1nnlb77i13',
            '9bh9bo8nka30'
          ],
          dependencyPackages: [
            {
              id: 'a5chmgxs7219',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        '7jbrmnpu41z1': {
          groupId: 'lt-4wd-pkg0',
          accessoryIds: [
            'mtjkzka4hyry',
            'qrlyo2fi1cz5'
          ],
          dependencyPackages: [
            {
              id: 'a5chmgxs7219',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        y2dzpqaviuzr: {
          groupId: 'lt-4wd-pkg1',
          accessoryIds: [
            '22r2iguvwna5'
          ],
          dependencyPackages: [
            {
              id: '17qszcfj0bo2',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        y2dzpqaviuz2: {
          groupId: 'lt-2wd-pkg1',
          accessoryIds: [
            'oakqa7avxhmq'
          ],
          dependencyPackages: [
            {
              id: 'y2dzpqaviuz1',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        tfdp0ldjts3m: {
          groupId: 'lt-2wd-pkg0',
          accessoryIds: [
            'yn2ooyds378y'
          ],
          dependencyPackages: [
            {
              id: 'nlkpwwp04yae',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        nlkpwwp04yae: {
          groupId: 'lt-2wd-pkg0',
          accessoryIds: [
            '2plajrmvths5'
          ],
          dependencyPackages: [
            {
              id: '7jbrmnpu41zt',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025'
          ]
        },
        'nlkpwwp04yae-my26': {
          groupId: 'lt-2wd-pkg0',
          accessoryIds: [
            '2plajrmvths5'
          ],
          dependencyPackages: [
            {
              id: '7jbrmnpu41zt',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2026'
          ]
        },
        wxq5g7rzvivx: {
          groupId: 'lt-2wd-pkg0',
          accessoryIds: [
            'ptvlbx4oakbu',
            'k1tgm4d8un58',
            'czxgco8l62fv'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        ysk7er2cyj1ffds: {
          groupId: 'lt-2wd-pkg0',
          accessoryIds: [
            'lrpq8u8zpdb1',
            'lsc3om940tkg',
            '3fuv04x49k8u'
          ],
          dependencyPackages: [
            {
              id: 'nlkpwwp04yae',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        '7jbrmnpu41zt': {
          groupId: 'lt-2wd-pkg0',
          accessoryIds: [
            'l9o7n2dgqf4r321',
            'mwawbqfdlt3b'
          ],
          dependencyPackages: [
            {
              id: 'nlkpwwp04yae',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        y2dzpqaviuz1: {
          groupId: 'lt-2wd-pkg1',
          accessoryIds: [
            'oakqa7avxhmq'
          ],
          dependencyPackages: [
            {
              id: 'y2dzpqaviuz2',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        tupambf5esb8: {
          groupId: 'ls-4wd-pkg1',
          accessoryIds: [
            'itbl6bdvdboy'
          ],
          dependencyPackages: [
            {
              id: 'y2dzpqaviuz3',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        y2dzpqaviuz3: {
          groupId: 'ls-4wd-pkg1',
          accessoryIds: [],
          dependencyPackages: [
            {
              id: 'tupambf5esb8',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        wcjcjdf6vud7: {
          groupId: 'ls-4wd-pkg0',
          accessoryIds: [
            'rgm1s2u48s3z',
            '8lz29kitnkam',
            '5zc0rx55r9q9'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        '4e8rsvm8yulq0': {
          groupId: 'ls-2wd-pkg1',
          accessoryIds: [
            '3ckvx6gvve79'
          ],
          dependencyPackages: [
            {
              id: 'y2dzpqaviuz4',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        },
        ysk7er2cyj1f34: {
          groupId: 'ls-2wd-pkg0',
          accessoryIds: [
            '3ckvx6gvve67',
            '56cy0d0cnz7u',
            '496aqzregvz5'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        },
        y2dzpqaviuz4: {
          groupId: 'ls-2wd-pkg1',
          accessoryIds: [],
          dependencyPackages: [
            {
              id: '4e8rsvm8yulq0',
              autoRemove: false
            }
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        }
      },
      interactions: {
        xbdzchklx04d: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        '9a4ewd0iqpwk': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        fwou2afhghpp: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        bkr8amy2tvbs: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        '6146uzbd6kui': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        iq7p37hq4g0j: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        z1338jyjvioh: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ]
        },
        whla8blk6rfp: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          dependsOn: [
            '9a4ewd0iqpwk'
          ]
        },
        '9sdtnnxpfmab': {
          type: 'flicker',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-4wd-2025',
            'premier-4wd-2026'
          ],
          flickerFrequency: 1,
          flickerDelay: 0,
          waitForFullfill: true,
          availableFor: {
            accessories: [
              '4fjgp644j954'
            ]
          }
        },
        a9037m7w0amd: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        '9vjnbyvcm8ye': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        xvlpl9hn6ljm: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        fih0thha3470: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        '44otdgfdocii': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        '2oa1nn1eq5ws': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        tzk3p1e9inza: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ]
        },
        petliz6yx4hn: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          dependsOn: [
            '9vjnbyvcm8ye'
          ]
        },
        b47gdog8ibnv: {
          type: 'flicker',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'premier-2wd-2025',
            'premier-2wd-2026'
          ],
          flickerFrequency: 1,
          flickerDelay: 0,
          waitForFullfill: true,
          availableFor: {
            accessories: [
              'wf9709z90ina23'
            ]
          }
        },
        '0vth6kpxs1jg': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        kisy9chslzdy: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        '73ziza3xg8ou': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          availableFor: {
            accessories: [
              'ze9qelaq0ea7'
            ]
          }
        },
        '4xi4tptsom06': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        ak1tl37gumgs: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          availableFor: {
            accessories: [
              'do59cklquwhw'
            ]
          }
        },
        v713uc2xqr67: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        isdzpznxq6g8: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ]
        },
        yplmpl5hbfjn: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          dependsOn: [
            'kisy9chslzdy'
          ]
        },
        v7ns4gk7q7x4: {
          type: 'flicker',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'z71-4wd-2025',
            'z71-4wd-2026'
          ],
          flickerFrequency: 1,
          flickerDelay: 0,
          waitForFullfill: true
        },
        dscofhz7g4yx: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ]
        },
        xy419msn5u11: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ]
        },
        '55mqnedm4ie5': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          availableFor: {
            accessories: [
              'rye7d6mc16r0'
            ]
          }
        },
        sqb2g38cd9f6: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ]
        },
        vwruq487gini: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          availableFor: {
            accessories: [
              'e3cpetqtxy02'
            ]
          }
        },
        lgzk0rcg6nra: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ]
        },
        '66sikckzjmb5': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'FOG_GLOW',
              identifiers: [
                'exterior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ]
        },
        ga1j8nalmcub: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          dependsOn: [
            'xy419msn5u11'
          ]
        },
        n2nwscexca19: {
          type: 'flicker',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: true,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-4wd-2025',
            'rst-4wd-2026'
          ],
          flickerFrequency: 1,
          flickerDelay: 0,
          waitForFullfill: true
        },
        nr092e0zwxmq: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        n3srfdzi1l8y: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        '349fglfh95t5': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          availableFor: {
            accessories: [
              'fpfkrtu6uh3e'
            ]
          }
        },
        '0spridh8lbtj': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        iatxs9qe275v: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          availableFor: {
            accessories: [
              'ilcd1ac7uwte'
            ]
          }
        },
        ohkbhiy361mh: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        xrckn309uytv: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          dependsOn: [
            'n3srfdzi1l8y'
          ]
        },
        hwol9wjk8u5f: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        a0b4x8u9auhj: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        '2mbv5mgd2j0t': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          availableFor: {
            accessories: [
              '0zwxk45hp9q3'
            ]
          }
        },
        qt4x1krtddkb: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        z93m8aegiqzi: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          availableFor: {
            accessories: [
              '2plajrmvths5'
            ]
          }
        },
        bq3rqckxu99j: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ]
        },
        szn7n8dgwxam: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-2wd-2025',
            'lt-2wd-2026'
          ],
          dependsOn: [
            'a0b4x8u9auhj'
          ]
        },
        glpt65jo78y2: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        t6e4q7plmhff: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        ksc6tjza73uc: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        '9tzgl55xbnhv': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ]
        },
        r7u7zjrxkryo: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-4wd-2025',
            'ls-4wd-2026'
          ],
          dependsOn: [
            't6e4q7plmhff'
          ]
        },
        f9s7b4hdeiz7: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        },
        '1nad76ictp6j': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        },
        '3cqy8q29b96c': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        },
        '1dzdmvhl8vp3': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ]
        },
        vb0nbeis8kuj: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SEAT_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SEAT_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'ls-2wd-2025',
            'ls-2wd-2026'
          ],
          dependsOn: [
            '1nad76ictp6j'
          ]
        }
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0
            },
            isFovZoomModeOn: false
          }
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_3',
            identifiers: [
              'common_exterior'
            ]
          }
        }
      },
      usdzPathWithVariable: ''
    }
  }
};
